import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PageHeader from "components/Common/PageHeader";
import SideBarSchoolSettings from "feature-module/settings/components/SideBarSchoolSettings";
import { Button } from "antd";
import { all_routes } from "router/all_routes";
import Loader from "components/Common/loader";
import CustomButton from "components/Common/ui/CustomButton";

interface SettingsLayoutProps {
    titleKey: string;            // i18n key for title
    children: React.ReactNode;   // inner page content
    filterFields?: any;
    filters?: any;
    handleFilter?: any;
    loading?: boolean;
}

const SettingsLayout: React.FC<SettingsLayoutProps> = ({ titleKey, children, loading = false }) => {
    const { t } = useTranslation();

    const breadcrumbItems = [
        { label: t("settingsPage.title") , path: all_routes.allSettings },
        { label: t(titleKey), active: true },
    ];

    return (
        <div className="page-wrapper">
            <div className="content container-fluid">
                <PageHeader title={t(titleKey)} breadcrumbItems={breadcrumbItems} />
                <div className="d-flex justify-content-end mb-3">
                    <CustomButton
                        asLink
                        to={all_routes.allSettings}
                        className="btn btn-light border d-inline-flex align-items-center shadow-sm px-3 py-2 rounded-2 hover-scale"
                    >
                        <i className="ti ti-arrow-left me-2" />
                        <span className="fw-semibold">{t("settingsPage.back_to_list")}</span>
                    </CustomButton>
                </div>

                {loading ? (
                    <Loader />
                ) : (
                    children
                )}
            </div>
        </div>
    );
};

export default SettingsLayout;
